import { render, staticRenderFns } from "./serial-profile.vue?vue&type=template&id=3f9ec29d&scoped=true&"
import script from "./serial-profile.vue?vue&type=script&lang=js&"
export * from "./serial-profile.vue?vue&type=script&lang=js&"
import style0 from "./serial-profile.vue?vue&type=style&index=0&id=3f9ec29d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9ec29d",
  null
  
)

export default component.exports